<template>
  <div class="form-group">
    <i class="ColorRed">*</i>
    <label for="operatingIncome">{{ label }}</label>
    <slot />
  </div>
</template>
<script>
export default {
  nameL: "label",
  props: {
    label: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss">
.ColorRed{
    color :red;
    margin-right:5px;
}
</style>
